function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.4219 13.625H2.57812C2.15625 13.625 1.875 13.3438 1.875 12.9219V4.48438C1.875 4.0625 2.15625 3.78125 2.57812 3.78125H4.6875V5.1875H3.28125V12.2188H11.7188V8.70312H13.125V12.9219C13.125 13.3438 12.8438 13.625 12.4219 13.625Z",
  fill: "#011FBB"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.90625 4.48438C6.65625 4.48438 4.6875 6.24219 4.6875 9.40625C5.46094 8.21094 6.375 7.29688 8.90625 7.29688V9.40625L13.125 5.89062L8.90625 2.375V4.48438Z",
  fill: "#011FBB"
});

const SvgExportData = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgExportData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/export_data.bcf935fd.svg";
export { ForwardRef as ReactComponent };